export default __webpack_public_path__ + "images/slide_1.jpeg?517caef60e4e9bd88045647e2511a04a";